module.exports = __webpack_public_path__ + "img/B2B2C_customer1.72219388.png";